"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plexUrl = void 0;
const plexUrlParams_1 = require("./plexUrlParams");
const PLEX_HOST = 'https://app.plexhq.io';
function plexUrl({ host = PLEX_HOST, pathname, params, }) {
    const search = plexUrlParams_1.searchWithPlexUrlParams({ search: '' }, params);
    return `${host}${pathname}?${search}`;
}
exports.plexUrl = plexUrl;
//# sourceMappingURL=plexUrl.js.map